import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto max-w-xl rounded-lg overflow-hidden shadow-2xl bg-dCard p-5 font-mono" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-4xl p-5 text-dDollar" }, "Minesweeper 2P", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", null, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.roomIdInput) = $event)),
        class: "bg-dBg text-dInput p-3 text-3xl rounded-md",
        autofocus: ""
      }, null, 512), [
        [_vModelText, _ctx.roomIdInput]
      ]),
      _createElementVNode("button", {
        type: "submit",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.joinRoom && _ctx.joinRoom(...args)), ["prevent"])),
        class: "text-dButton m-5 border-b-2 border-transparent hover:border-dButton text-3xl"
      }, " Create or Join Room ")
    ])
  ]))
}